import React, { useState, useEffect } from "react";
import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import "./TitleWithSearch.css";
import NewButton from "../../NewComponents/NewButton";

const CouponTitleWithSearch = ({
  title,
  onSearch,
  placeholder,
  onAddMemberClick,
  addBtnText = "Add Coupon",
  windowSize
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (searchQuery.length > 1) {
      const timer = setTimeout(() => {
        onSearch(searchQuery);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      onSearch("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  return (
    <div className="TitleWithSearchBox TitleWithSearchBox lg:flex-row flex-col">
      <h2 className="MainTitle">{title}</h2>

      <div className="lg:w-fit w-full grid sm:grid-cols-3 grid-cols-1 gap-4">
        <div className="sm:col-span-2">
          <label className="SearchBox !w-full">
            <SEARCHICON className="SearchIcon" />
            <input
              className="SearchInput"
              placeholder={placeholder}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              type="search"
            />
          </label>
        </div>
        <NewButton
          text={addBtnText}
          onClick={onAddMemberClick}
          back
          icon={false}
          whiteBtn
          width={windowSize?.width > 1024 ? "150px" : "100%"}
        />
      </div>
    </div>
  );
};

export default CouponTitleWithSearch;
